module.exports = __webpack_public_path__ + "static/media/redcycle-demo.284fc8b9.gif";